module.exports = __webpack_public_path__ + "img/spot.f5a66532.png";